const types = {
  SET_LIST_ACTIONS: 'SET_LIST_ACTIONS',
  SET_LIST_ANSWERS: 'SET_LIST_ANSWERS',
  REMOVE_ITEM_ACTIONS: 'REMOVE_ITEM_ACTIONS',
  REMOVE_ITEM_ANSWERS: 'REMOVE_ITEM_ANSWERS',
  SET_ACTION: 'SET_ACTION',
  SET_ANSWER: 'SET_ANSWER',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/trash/mutations-types.js